export default "__VITE_ASSET__C5lbn_fh__"